import axios from 'axios';

function getCommonParams() {
  return {
    CToken: window?.highEndInfo?.ctoken || '',
    UserId: window?.highEndInfo?.uid || '',
    Version: window?.highEndInfo?.appv || '6.7.0',
    CustomerNo: window?.highEndInfo?.uid || '',
    UToken: window?.highEndInfo?.utoken || '',
    AppType: window?.highEndInfo?.app || 'ttjj',
    MobileKey: window?.highEndInfo?.deviceid || '1234567.py.service',
    ServerVersion: window?.highEndInfo?.serverversion || '6.7.0',
    BType: '1',
    PhoneType: window?.highEndInfo?.plat || '1',
  };
}

function getCommonHeaders() {
  return {
    'Content-Type': 'application/json',
  };
}

/**
 * 调用基金风险匹配接口
 * @param {Object} dynamicParams - 动态参数（如 FundCode）
 * @returns {Promise} - 返回接口响应数据
 */
export async function fetchRiskMatchData(dynamicParams) {
  try {
    // 合并公共参数和动态参数
    const commonParams = getCommonParams();
    const requestData = { ...commonParams, ...dynamicParams };
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '1') {
      zoneStr = '';
    }

    // zoneStr = '1';
    // 发送 POST 请求
    const response = await axios.post(
      `https://tradeapilvs${zoneStr}.1234567.com.cn/User/Account/GetCustomerInfo`,
      requestData,
      { headers: getCommonHeaders() },
    );
    console.log(zoneStr);
    // 返回响应数据
    return response.data;
  } catch (err) {
    console.error('请求出错:', err.message);
    throw err; // 抛出错误，由调用方处理
  }
}

/**
 * 调用基金风险匹配接口
 * @param {Object} dynamicParams - 动态参数（如 FundCode）
 * @returns {Promise} - 返回接口响应数据
 */
export async function fetchUserRiskMatchFund(dynamicParams) {
  try {
    // 合并公共参数和动态参数
    const commonParams = getCommonParams();
    const requestData = { ...commonParams, ...dynamicParams };
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '1') {
      zoneStr = '';
    }

    // 发送 POST 请求
    const response = await axios.post(
      `https://tradeapilvs${zoneStr}.1234567.com.cn/Business/home/UserRiskMatchFund`,
      requestData,
      { headers: getCommonHeaders() },
    );
    console.log(zoneStr);
    // 返回响应数据
    return response.data;
  } catch (err) {
    console.error('请求出错:', err.message);
    throw err; // 抛出错误，由调用方处理
  }
}

/**
 * 调用基金风险匹配接口
 * @param {Object} dynamicParams - 动态参数（如 FundCode）
 * @returns {Promise} - 返回接口响应数据
 */
export async function fetchGetLastRiskAnswer(dynamicParams) {
  try {
    // 合并公共参数和动态参数
    const commonParams = getCommonParams();
    const requestData = { ...commonParams, ...dynamicParams };
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '1') {
      zoneStr = '';
    }

    // 发送 POST 请求
    const response = await axios.post(
      `https://tradeapilvs${zoneStr}.1234567.com.cn/user/home/GetLastRiskAnswer`,
      requestData,
      { headers: getCommonHeaders() },
    );
    console.log(zoneStr);
    // 返回响应数据
    return response.data;
  } catch (err) {
    console.error('请求出错:', err.message);
    throw err; // 抛出错误，由调用方处理
  }
}

export async function fetchAuditAndSignData(dynamicParams) {
  try {
    // 合并公共参数和动态参数
    const commonParams = getCommonParams();
    const requestData = { ...commonParams, ...dynamicParams };
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '') {
      zoneStr = '1';
    }
    // 发送 POST 请求
    const response = await axios.post(
      `https://ibgapi${zoneStr}.1234567.com.cn/senior/product/getAuditAndSignResult`,
      requestData,
      { headers: getCommonHeaders() },
    );

    // 返回响应数据
    return response.data;
  } catch (err) {
    console.error('请求出错:', err.message);
    throw err; // 抛出错误，由调用方处理
  }
}

export async function isAuditNeedPop() {
  try {
    // 合并公共参数和动态参数
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '') {
      zoneStr = '1';
    }
    // 发送 POST 请求
    const response = await axios.post(
      `https://ibgapi${zoneStr}.1234567.com.cn/senior/product/isAuditNeedPop`,
      {},
      { headers: getCommonHeaders() },
    );

    // 返回响应数据
    return response;
  } catch (err) {
    console.error('请求出错:', err.message);
    throw err; // 抛出错误，由调用方处理
  }
}

export async function auditPopRecord() {
  try {
    // 合并公共参数和动态参数
    const commonParams = getCommonParams();
    const requestData = {
      ...commonParams,
      content:
        '若您有意进行私募资产管理产品投资，请确认您符合法规规定的“合格投资者”标准，'
        + '即具备相应的风险识别能力和风险承担能力，投资于单只产品符合产品合同约定的起投金额，'
        + '且需具有2年以上投资经历，并满足以下条件之一：1、家庭金融资产≥500万；2、家庭金融净资产≥300万；'
        + '3、近3年本人年均收入≥50万。并且，您对天天基金及其平台销售的私募资产管理产品有一定的了解，是天天基金的优质注册客户。',
    };
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '') {
      zoneStr = '1';
    }

    // 发送 POST 请求
    const response = await axios.post(
      `https://ibgapi${zoneStr}.1234567.com.cn/senior/product/auditPopRecord`,
      requestData,
      { headers: getCommonHeaders() },
    );

    // 返回响应数据
    return response.data;
  } catch (err) {
    console.error('请求出错:', err.message);
    throw err; // 抛出错误，由调用方处理
  }
}

export async function getProductSeatsInfo(params = {}) {
  try {
    const commonParams = getCommonParams();
    const requestData = { ...commonParams, ...params };
    // 合并公共参数和动态参数
    const zone = window?.highEndInfo?.zone || '';
    let zoneStr = zone;
    if (zone === '') {
      zoneStr = '1';
    }
    // 发送 POST 请求
    const response = await axios.post(
      `https://ibgapi${zoneStr}.1234567.com.cn/senior/product/getProductSeatsInfo`,
      requestData,
      { headers: getCommonHeaders() },
    );

    // 返回响应数据
    return response;
  } catch (err) {
    console.error('请求出错:', err.message);
    throw err; // 抛出错误，由调用方处理
  }
}
